var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"gl-heading-2 gl-mt-3"},[_vm._t("default")],2),_vm._v(" "),_vm._t("description")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }